'use client';
import { proxy, subscribe } from 'valtio';

export interface AbsolutDepthsSettingsState {
    isDisplayMinusAbsDepths: boolean;
}

export const defaultAbsolutDepthsSettingsState = {
    isDisplayMinusAbsDepths: false,
};

const localStorageKey = 'absolutDepthsSettings';

const loadState = (): AbsolutDepthsSettingsState => {
    if (typeof window === 'undefined') {
        return { ...defaultAbsolutDepthsSettingsState };
    }

    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            // Ensure it's running in the browser
            const storedState = localStorage.getItem(localStorageKey);
            return storedState ? JSON.parse(storedState) : { ...defaultAbsolutDepthsSettingsState };
        }
    } catch (error) {
        console.error('Ошибка загрузки состояния из localStorage:', error);
    }
    return { ...defaultAbsolutDepthsSettingsState };
};

const saveState = (state: AbsolutDepthsSettingsState) => {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        }
    } catch (error) {
        console.error('Error saving state to localStorage:', error);
    }
};

export const absolutDepthsSettings = proxy<AbsolutDepthsSettingsState>({ ...defaultAbsolutDepthsSettingsState });

if (typeof window !== 'undefined') {
    const initialState = loadState();
    Object.assign(absolutDepthsSettings, initialState);
}

if (typeof window !== 'undefined') {
    subscribe(absolutDepthsSettings, () => {
        saveState(absolutDepthsSettings);
    });
}
